import { REGIONS } from 'v2/configs/constants'

export const getRegionLabel = (region: string) => (region === REGIONS.IN ? 'India' : 'US')
